import {
    COMMUNITY_ITEM_RESPONSE,
    PROJECT_LIST_RESPONSE,
    UNAUTHENTICATED,
    COMMUNITY_ITEM_SAVE_RESPONSE
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data } = action
    switch (type) {
        case PROJECT_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case COMMUNITY_ITEM_SAVE_RESPONSE:
        case COMMUNITY_ITEM_RESPONSE:
            return extractEntitiesFromData(data.projects, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
